import { AsidePanelActionsButton } from '../../../../..';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import * as React from 'react';
import { IArchiveOnDeletePanelButtonProps } from './types';
import { BOARD_SECTION_ARCHIVE_ON_DELETE_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function ArchiveOnDeletePanelButton ({
    indicatorBoolean,
    isEssentialFeature,
    isDisabled,
    isBoardSplitSettings,
    tooltip,
    onClick
}: IArchiveOnDeletePanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={isBoardSplitSettings && subTab === EBoardSetting.ARCHIVE_UPON_DELETION}
            indicatorBoolean={indicatorBoolean}
            isEssentialFeature={isEssentialFeature}
            isDisabled={isDisabled}
            sectionSelector={!isBoardSplitSettings && `.${CLASS_BOARD_DETAILS_SECTION}--archive-on-del`}
            title={BOARD_SECTION_ARCHIVE_ON_DELETE_BUTTON}
            tooltip={tooltip}
            onClick={() => {
                if (isBoardSplitSettings) setSubTab(EBoardSetting.ARCHIVE_UPON_DELETION);
                onClick();
            }}
        />
    );
}
